import { AbstractControl, ValidatorFn } from '@angular/forms';

export interface AbstractControlWarn extends AbstractControl {
  warnings: unknown;
}

export function Budget10kWarning(rowId: string) {
  return (control: AbstractControlWarn): ValidatorFn => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);
      const anyUnder10K = parsedValue
        .filter((pv) => pv.rowId === rowId && pv.value)
        .some((pv) => pv.value < 10_000);
      const valObject = { [`Budget10kWarning_${rowId}`]: true };

      control.warnings = anyUnder10K ? valObject : undefined;
    }

    return undefined;
  };
}
